// src/components/SearchForm/SearchForm.js
import React from 'react';
import { Form, Button } from 'react-bootstrap';
import './SearchForm.css';

const SearchForm = ({ formData, handleInputChange, handleSubmit }) => {
  const previewKeywords = formData.keyword
    .replace(/\r/g, '')
    .split(/[\n,]+/)
    .map((kw) => kw.trim())
    .filter(Boolean);

  const keywordCount = previewKeywords.length;

  return (
    <div className="sidebar search-sidebar form-entrance">

      <Form onSubmit={handleSubmit}>
        <Form.Group className="mb-4">
          <Form.Label><strong>Keywords</strong></Form.Label>
          <Form.Control
            as="textarea"
            rows={4}
            name="keyword"
            placeholder="Enter keywords separated by commas or new lines"
            value={formData.keyword}
            onChange={handleInputChange}
            className="keyword-textarea"
          />
         
        </Form.Group>

        {keywordCount > 0 && (
          <div className="keyword-preview mb-3">
            <div className="preview-header">Preview keywords ({keywordCount})</div>
            <div className="preview-tags">
              {previewKeywords.map((keyword, index) => (
                <span key={`${keyword}-${index}`} className="preview-tag">
                  {keyword}
                </span>
              ))}
            </div>
          </div>
        )}

        <Form.Group className="mb-3">
          <Form.Label>Country</Form.Label>
          <Form.Select
            name="country"
            value={formData.country}
            onChange={handleInputChange}
          >
            <option value="2356">India</option>
            <option value="2840">United States</option>
            <option value="2826">UK</option>
            <option value="2036">Australia</option>
          </Form.Select>
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Language</Form.Label>
          <Form.Select
            name="language"
            value={formData.language}
            onChange={handleInputChange}
          >
            <option value="1000">English</option>
          </Form.Select>
        </Form.Group>

        <ul className="info-list p-3 rounded small mb-3">
          <li>Send up to 20 keywords at once.</li>
          <li>Comma and newline input are both supported.</li>
          <li>Results cover the last 12 months.</li>
        </ul>

        <Button type="submit" className="w-100 btn-search-submit animated-submit">
          <i className="bi bi-lightning-charge me-2"></i> Analyze Keywords
        </Button>
      </Form>
    </div>
  );
};

export default SearchForm;
